var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      { staticClass: "filter-header__dense" },
      [
        _c(
          "div",
          {
            class: [
              "header-name-display",
              _vm.singleIcon ? "single-icon" : "",
              _vm.hideFilterInput ? "no-filter" : ""
            ]
          },
          [
            _c("sort-icons", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hideFilterInput,
                  expression: "!hideFilterInput"
                }
              ],
              attrs: { "sort-dir": _vm.sortDir },
              on: {
                change: function(dir) {
                  return _vm.changeSort(dir, _vm.label)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-text-display" },
              [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.label))])])],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hideFilterInput
          ? _c("multi-type-filter-input", {
              attrs: {
                value: _vm.value,
                type: _vm.type,
                "filter-type": _vm.filterType
              },
              on: { updated: _vm.updateFilter }
            })
          : _c("div", { staticClass: "input-controls" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }